import { styled } from 'styled-components';

export const GuideContainer = styled.div`
    display: flex;
    align-items: center;
    gap:1rem;
    position: absolute;
    top: 1rem;
    left: 2rem;

    background-color: ${props=>props.showInfo === "true" && !props.isAdm ? "var(--red-style-color)" : "var(--red-style-color)"} !important;
    padding: 0.3rem 0.5rem;
    border-radius: 2px;

    button{
        display: flex;
        align-items: center;
        justify-content: center;
        border: none;
        background-color: transparent;

    }

    .location{
        display: flex;
        gap: 0.5rem;
    }

    .pop-up{
        display: flex;
        position: absolute;
        top: 40px;
        left: 0px;
        width: 100%;
        background: #fff;
        border-radius: 2px;
        cursor: pointer;
         
        span{
            padding: 10px;
            width: 100%;

            &:hover{
                background: #111;
                color: #fff;
            }
        }
    }

`;